<template>
  <div class="mt-4 mb-4">
    <b-card border-variant="primary" header-text-variant="primary" v-for="(codevedor, index) in codevedores"
      v-bind:key="codevedor.id_codevedor">
      <template v-slot:header>
        {{especie === 'CH' ? 'Informações do Co-emitente' : 'Informações do Devedor'}} [{{+ + index + 1 }}]
        <span v-b-popover.hover.top="'Pessoa Física ou Jurídica responsável pelo pagamento do título ou documento de dívida.'
          " title="Devedor" class="infolet">
          i
          <!-- <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="blue"
                      /> -->
        </span>
      </template>
      <b-card-text>
        <b-row>


          <b-col cols="12" md="4" lg="4">
            <label for="documento_devedor">CPF/CNPJ:</label>
            <b-input v-model="codevedor.nm_nr_documento" placeholder="Documento" maxlength="18"
              :state="codevedor.state.documento" :formatter="documento" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)" @blur="
                validarDocumento(
                  'validations.documento_codevedor',
                  $event,
                  codevedor.id_codevedor
                ); consultaCnpj('devedor')
                ">
            </b-input>
            <b-form-invalid-feedback :state="codevedor.state.documento">
              Infome um documento válido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="4" lg="8">
            <label for="nome_solicitante">Nome:</label>
            <b-input v-model="codevedor.nm_nome" maxlength="45" placeholder="Nome" :state="codevedor.state.nome"
              id="outorgante_nome" required @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.nome">
              Infome o nome.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-2">

          <b-col cols="12" md="8">
            <label for="email_sacador">Email:</label>
            <b-input v-model="codevedor.email_devedor" placeholder="email" maxlength="50" required>
            </b-input>
            <b-form-invalid-feedback :state="codevedor.state.email_devedor">
              E-mail inválido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="4">
            <label for="nome_solicitante">Contato:</label>
            <b-input v-model="codevedor.celular_devedor" :formatter="Celular" maxlength="15"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12" lg="12">
            <h4 class="text-primary mt-5">Endereço:</h4>
            <hr />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="3" lg="3">
            <label for="outorgante_cep">CEP:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_nr_cep_devedor"
              @input="populaendereco(codevedor.id_codevedor)" maxlength="9" type="text" placeholder="_____-___"
              :state="codevedor.state.cep" :formatter="cep" id="endereco_sacador" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.cep">
              CEP inválido.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <label for="outorgante_logradouro">Logradouro:</label>
            <b-input v-model="codevedor.endereco_devedor.logradouro"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="30" type="text" placeholder="Logradouro"
              :state="codevedor.state.endereco_logradouro" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco_logradouro">
              Logradouro inválido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_numero">Número:</label>
            <b-input v-model="codevedor.endereco_devedor.numero"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="5" type="text" placeholder="Número"
              :state="codevedor.state.endereco_numero" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco_numero">
              Número do endereço inválido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_complemento">Complemento: <i>(Opcional)</i></label>
            <b-input v-model="codevedor.endereco_devedor.complemento"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="10" type="text" placeholder="Complemento"></b-input>
          </b-col>
          <!-- <b-col cols="12" md="6">
            <label for="outorgante_endereco">Endereço:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_endereco_devedor"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="45" type="text" placeholder="Endereço"
              :state="codevedor.state.endereco" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco">
              Endereço inválido.
            </b-form-invalid-feedback>
          </b-col> -->
          <b-col cols="12" md="6">
            <label for="outorgante_bairro">Bairro:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_bairro_devedor" maxlength="20" type="text" placeholder="Bairro"
              :state="codevedor.state.bairro" id="outorgante_bairro" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.bairro">
              Informe o Bairro.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_cidade">Cidade:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_cidade_devedor" maxlength="20" type="text" placeholder="Cidade"
              :state="codevedor.state.cidade" id="outorgante_cidade" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.cidade">
              Informe a Cidade.
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_uf">UF</label>
            <b-select v-model="codevedor.endereco_devedor.cd_uf" :options="estados" :state="codevedor.state.uf" required
              @change="atualizaDadosendereco(codevedor.id_codevedor)"></b-select>

            <div class="select-arrow-down"></div>
            <b-form-invalid-feedback :state="codevedor.state.uf">
              Informe a UF .
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="5" class="mt-4">
            <label><b-button variant="danger" @click="removerCodevedor(codevedor.id_codevedor)"> <font-awesome-icon
                  icon="trash" />&nbsp;&nbsp; {{especie === 'CH' ? 'Remover Co-emitente' : 'Remover Codevedor'}}</b-button></label>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import axios from "axios";
import API from "../../services/api";
import Serv from "../../services";

export default {
  props: ['codevedores', 'estados', 'docDevedor', 'docCedente', 'docSacador', 'especie'],
  data() {
    return {
      emailValidationRegex: /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/g,
      devedor_cep: "",
      // codevedor_cep:"",
      id_codevedor: "",
      indexCodevedor: null,
      dadosCep: {
        nm_nr_cep_devedor: "",
        nm_endereco_devedor: "",
        logradouro:'',
        numero:'',
        complemento:'',
        sg_uf_devedor: "",
        cd_uf: "",
        nm_cidade_devedor: "",
        nm_bairro_devedor: ""
      },
      form: {
        nome_devedor: "",
        documento_devedor: "",
        email_devedor: "",
        celular_devedor: "",
        endereco_devedor: {
          nm_nr_cep_devedor: "",
          nm_endereco_devedor: "",
          nm_cidade_devedor: "",
          cd_uf: "",
          sg_uf_devedor: "",
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          nm_bairro_devedor: "",
        },
      },
      validations: {

        nome_devedor: null,
        documento_devedor: null,
        endereco_devedor_cep: null,
        endereco_devedor_endereco: null,
        endereco_devedor_endereco_logradouro: null,
        endereco_devedor_endereco_numero: null,
        endereco_devedor_numero: null,
        endereco_devedor_cidade: null,
        endereco_devedor_bairro: null,
        endereco_devedor_uf: null,
        email_devedor: null,

      }
    }
  },
  methods: {
    validateEmail(event, id_codevedor) {
      let email = event.target.value
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor);
      this.$props.codevedores[indexCodevedor].state.email_devedor  = (email != null && email != '') ? this.emailValidationRegex.test(email) : true;
    },
    validarDocumento(validation, event, id_codevedor) {
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor);
      if (event != null) {
        let documento = event.target.value
          .replace(".", "")
          .replace(".", "")
          .replace("-", "")
          .replace("/", "");
        if (documento.length > 11) {
          if (!Serv.validarCNPJ(documento)) this[validation] = false;
          else this[validation] = true;
          this.$emit('updateBloqueio9430', false);
        } else {
          if (!Serv.validarCPF(documento)) this[validation] = false;
          else this[validation] = true;
          this.$emit('updateBloqueio9430', true);
        }
      } else this[validation] = false;

      //validar não permitir que o Documento do Devedor seja igual ao Documento do Sacador ou do Cedente. 
      let docCodevedor = this.$props.codevedores[indexCodevedor].nm_nr_documento;
      let codevedorDuplicado = this.$props.codevedores.filter(d => d.nm_nr_documento == docCodevedor && d.id_codevedor != id_codevedor);
      if (codevedorDuplicado.length > 0) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Devedor/Codevedor");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docSacador != '') && (this.docSacador === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docCedente != '') && (this.docCedente === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docDevedor != '') && (this.docDevedor === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Devedor/Codevedor");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      }
      docCodevedor = docCodevedor.replace(".", "")
                                  .replace(".", "")
                                  .replace("-", "")
                                  .replace("/", "");
      if (docCodevedor != '') {
        console.log(docCodevedor)
        console.log(docCodevedor.length)
        if(docCodevedor.length == 14) this.consultaCnpj(indexCodevedor);
        else this.consultaDocumento(indexCodevedor);
      }
    },
    consultaDocumento(indexCodevedor) {
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/consultaDevedor', {
        token: token,
        documento: this.$props.codevedores[indexCodevedor].nm_nr_documento
      }).then((res) => {
        let cep = res.data.dados.nm_nr_cep_devedor.substring(0, 5) + '-' + res.data.dados.nm_nr_cep_devedor.substring(5, 8);
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nome", res.data.dados.nm_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "email_devedor", res.data.dados.nm_email_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "celular_devedor", res.data.dados.nm_nr_celular_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_endereco_devedor", res.data.dados.nm_endereco_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_cidade_devedor", res.data.dados.nm_cidade_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_nr_cep_devedor", cep);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_bairro_devedor", res.data.dados.nm_bairro_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor", res.data.dados.sg_uf_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "uf", res.data.dados.sg_uf_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "cd_uf", this.estados.find((d) => d.text == res.data.dados.sg_uf_devedor).value);
        this.$set(this.$props.codevedores[indexCodevedor], "devedor_cep", cep);
        this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores });


      })
    },
    consultaCnpj(indexCodevedor) {
      const token = localStorage.getItem("jwtToken");
      const codevedor = this.$props.codevedores[indexCodevedor];

      // Verificar se o objeto codevedor é válido antes de continuar
      if (codevedor && codevedor.nm_nr_documento) {
        const cnpjCoDevedor = codevedor.nm_nr_documento.replace(/\D/g, '');

        API.post('protesto/empresa', {
          token: token,
          documento: cnpjCoDevedor
        }).then((res) => {
          if (res.data.status === true) {
            const servico = res.data.servico;
            let cep = servico.cep.substring(0, 5) + '-' + servico.cep.substring(5, 8);

            // Preencher os campos do objeto codevedores[indexCodevedor] com os dados retornados pela API
            this.$set(codevedor, "nm_nome", servico.nome);
            this.$set(codevedor, "email_devedor", servico.email);
            this.$set(codevedor, "celular_devedor", servico.contato);
            this.$set(codevedor.endereco_devedor, "nm_endereco_devedor", servico.endereco);
            this.$set(codevedor.endereco_devedor, "nm_cidade_devedor", servico.cidade);
            this.$set(codevedor.endereco_devedor, "nm_nr_cep_devedor", cep);
            this.$set(codevedor.endereco_devedor, "nm_bairro_devedor", servico.bairro);
            this.$set(codevedor.endereco_devedor, "sg_uf_devedor", servico.estado);
            this.$set(codevedor.endereco_devedor, "uf", servico.estado);
            this.$set(codevedor.endereco_devedor, "cd_uf", this.estados.find((d) => d.text == servico.estado).value);
            this.$set(codevedor, "devedor_cep", cep);

            // Emitir evento para informar o componente pai sobre a atualização dos dados dos co-devedores
            this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores });
          }
        }).catch((error) => {
          console.error('Erro ao consultar CNPJ:', error);
        });
      } else {
        console.error('Objeto codevedor inválido ou não possui a propriedade nm_nr_documento');
      }
    },
    documento: function (event) {
      var value = event;
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
    Celular: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{5})(\d)/, "$1-$2");
      return d;
    },
    cep: function (event) {
      var d = event;
      if (d != null) {
        d = d.replace(/\D/g, "");
        d = d.replace(/^(\d{5})(\d)/, "$1-$2");
        return d;
      }
    },
    removerCodevedor: function (codevedor) {
      //console.log(codevedor)
      let codevedores = this.$props.codevedores;
      let indexCodevedor = codevedores.findIndex(d => d.id_codevedor == codevedor)
      if (indexCodevedor > -1) codevedores.splice(indexCodevedor, 1)
      this.$emit('removecodevedor')

      // console.log(this.$props.codevedores.indexof( codevedores.filter( d => d.id_codevedor = codevedor)))

    },
    dadosCodevedor: function (id_codevedor) {
      return this.$props.codevedores.filter(d => d.id_codevedor == id_codevedor);
    },
    BuscarCep: function (cep) {
      var cepl = cep.replace("-", "");
      var self = this;
      try {
        // let uf = id + "_uf_disabled";
        // let cidade = id + "_cidade_disabled";
        axios
          .get(`https://viacep.com.br/ws/${cepl}/json/`)
          .then((resp) => {
            if (resp.data.erro == true) {
              self.$set(self.dadosCep, "nm_nr_cep_devedor", "");
              self.$set(self.dadosCep, "nm_endereco_devedor", "");
              self.$set(self.dadosCep, "nm_bairro_devedor", "");
              self.$set(self.dadosCep, "nm_cidade_devedor", "");
              self.$set(self.dadosCep, "logradouro", "");
              self.$set(self.dadosCep, "complemento", "");
              self.$set(self.dadosCep, "numero", "");
              self.$set(self.dadosCep, "cd_uf", "");
              self.$set(self.dadosCep, "sg_uf_devedor", "");
            } else {
              self.$set(self.dadosCep, "nm_nr_cep_devedor", cep)
              self.$set(self.dadosCep, "nm_endereco_devedor", (resp.data.logradouro + " " + resp.data.complemento).substr(0, 45))
              self.$set(self.dadosCep, "logradouro", resp.data.logradouro.substr(0, 30))
              // self.$set(self.dadosCep, "complemento", resp.data.complemento.substr(0, 10))
              self.$set(self.dadosCep, "sg_uf_devedor", resp.data.uf)
              self.$set(self.dadosCep, "nm_cidade_devedor", resp.data.localidade.substr(0, 20))
              self.$set(self.dadosCep, "nm_bairro_devedor", resp.data.bairro.substr(0, 20))
              let dadosUfSelecionada = self.estados.find(
                (d) => d.text == resp.data.uf
              );
              self.$set(self.dadosCep, "cd_uf", dadosUfSelecionada.value);
            }
            this.populaendereco(this.id_codevedor);
          })
          .catch(() => {
            //console.error('error')
          });
      } catch (error) {
        //console.error('error')
      }
    },
    atualizaDadosendereco(id_codevedor) {
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor)
      let enderecoCodevedor = this.$props.codevedores[indexCodevedor].endereco_devedor;
      this.$props.codevedores[indexCodevedor].endereco_devedor.nm_endereco_devedor = 
                                                              enderecoCodevedor.logradouro + ", "
                                                              + enderecoCodevedor.numero + 
                                                              (enderecoCodevedor.complemento ? " - " + enderecoCodevedor.complemento: "");

      let cd_uf = this.$props.codevedores[indexCodevedor].endereco_devedor.cd_uf
      let dadosUfSelecionada = this.estados.find((d) => d.value == cd_uf);
      if (dadosUfSelecionada != undefined) this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor", dadosUfSelecionada.text);

      this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores })
    },
    populaendereco(id_codevedor) {
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor)

      this.indexCodevedor = indexCodevedor;
      this.id_codevedor = id_codevedor
      // setTimeout(() =>{ 
      // this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "cep", this.dadosCep.cep);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_bairro_devedor", this.dadosCep.nm_bairro_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_endereco_devedor", this.dadosCep.nm_endereco_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "logradouro", this.dadosCep.logradouro);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "numero", this.dadosCep.numero);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "complemento", this.dadosCep.complemento);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_cidade_devedor", this.dadosCep.nm_cidade_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor", this.dadosCep.sg_uf_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "cd_uf", this.dadosCep.cd_uf);
      this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores })
      // },5)
      // if(indexCodevedor != this.indexCodevedor)
      // {
      this.$set(this.dadosCep, "nm_bairro_devedor", '');
      this.$set(this.dadosCep, "nm_cidade_devedor", '');
      this.$set(this.dadosCep, "nm_endereco_devedor", '');
      this.$set(this.dadosCep, "logradouro", '');
      this.$set(this.dadosCep, "numero", '');
      this.$set(this.dadosCep, "complemento", '');
      this.$set(this.dadosCep, "sg_uf_devedor", '');
      this.$set(this.dadosCep, "cd_uf", '');
      // }

    },
    codevedor_cep: function (id_codevedor) {
      return { value: this.$props.codevedores.find(d => d.id_codevedor == id_codevedor).endereco_devedor.nm_nr_cep_devedor }
    },
  },
  watch: {
    codevedores: {
      deep: true,
      handler(dadosCodevedor) {
        let enderecoDevedor = this.indexCodevedor != null ? dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor : ''
        if (this.indexCodevedor != null && dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor.length == 9 && (enderecoDevedor != this.dadosCep.nm_nr_cep_devedor)) {
          this.BuscarCep(dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor);
        }

      }

    },
  },
  created() {
  },
}
</script>
<style scoped>
#painel .card-header {
  font: normal normal 200 20px/41px 'Kanit', sans-serif;
  letter-spacing: -1%;
  padding: 13px 22px;
  color: var(--secondary-color) !important;
  background-color: transparent;
}

.card-body {
  border: none;
  box-shadow: 4px 4px 50px 0 #D1DBE2;
}

.card-header .infolet {
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border-radius: 100%;
  font: normal normal 400 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #FFFFFF;
  padding: 0px 10px 0px 9.5px;
  left: 5px !important;
  position: relative;
  top: -1.5px;
}

.card-text label {
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-bottom: 12px;
  margin-left: 30px;
}

.card-text input.form-control,
.card-text select.custom-select {
  background: var(--light-gray-color) 0% 0% no-repeat padding-box;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-align: left;
  border-radius: 40px;
  border: none;
  height: 49px;
  vertical-align: middle;
  padding-left: 30px;
}

.card-text select.custom-select {
  cursor: pointer;
}

.card-text .select-arrow-down {
  border-left: 5px solid #597EB5;
  border-top: 5px solid #597EB5;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transform: rotate(225deg);
  width: 9px;
  height: 9px;
  position: absolute;
  bottom: 15px;
  right: 28px;
  cursor: pointer;
}

.card-text input.form-control::placeholder {
  color: #A8A8A8;
}
</style>